import { render } from "./index.vue?vue&type=template&id=251cd1a8&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=251cd1a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-251cd1a8"

export default script